import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, Paper } from '@mui/material';

const AuthLayout: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
        p: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, sm: 5 },
            borderRadius: 3,
            overflow: 'hidden',
          }}
        >
          <Box
            component="img"
            src="/logo192.png"
            alt="Ozio Logo"
            sx={{
              height: 64,
              mx: 'auto',
              mb: 3,
              display: 'block',
            }}
          />
          <Outlet />
        </Paper>
      </Container>
    </Box>
  );
};

export default AuthLayout;
